import { FC } from 'react';
import { ICountry } from '../../../../types';

interface CountryFlagProps {
  country: ICountry;
}

export const CountryFlag: FC<CountryFlagProps> = ({ country }) => {
  if (!country?.assets?.flag?.url) return null;

  return (
    <img
      src={country.assets.flag.url}
      alt={country.name}
      className='w-6 h-6 rounded-full object-cover border-[0.5px] border-hiContrast flex-shrink-0'
    />
  );
};
